enum BUILD_PLATFORMS {
  MOBILE = 'MOBILE',
  DESKTOP = 'DESKTOP',
}

export default BUILD_PLATFORMS
